<section class="change-page-type-tooltip-container" (click)="$event.stopPropagation()">
  <div class="change-page-type-title">
    Choose the product page type
  </div>
  <div class="change-page-type-description">
    Would you like to showcase a product list or create<br>
    an overview page highlighting what you are selling?
  </div>
  <div>
    <div class="mb12">
      <input class="ds-radio ds-radio-dark" [checked]="selectedType === newPageType" (click)="selectedType = newPageType" type="radio" id="product" name="periodSwitch">
      <label for="product">Product List</label>
    </div>
    <div>
      <input class="ds-radio ds-radio-dark" [checked]="selectedType === 'ecommerce_landing'" (click)="selectedType = 'ecommerce_landing'" type="radio" id="yearly" name="periodSwitch">
      <label for="yearly">Overview Page</label>
    </div>
  </div>
  <div class="change-page-type-actions mt40">
    <button class="ds-btn-purple-blue"
            [ngClass]="{'ds-btn-disabled' : !selectedType}"
            (click)="selectedType && generate.emit(selectedType)">Generate</button>
  </div>
</section>
